import React from "react";
import ShopSection from "../components/ShopSection";
import ShippingOne from "../components/ShippingOne";
import BreadcrumbThree from "../components/BreadcrumbThree";
import { Helmet } from "react-helmet-async";

const ShopPage = () => {

  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "Village Zone",
    url: "https://store.villagezone.shop",
    logo: "https://store.villagezone.shop/assets/images/logo/logo.png",
    description:
      "Village Zone is a product by Rastelx Technologies Private Limited envisioned to make our society healthier.",
    email: "info@rastelx.com",
    address: {
      "@type": "PostalAddress",
      streetAddress: "11/470, MANJAPRA P.O",
      addressLocality: "Ernakulam",
      addressRegion: "Kerala",
      postalCode: "683581",
      addressCountry: "IN",
    },
    sameAs: [
      "https://www.instagram.com/thevillagezone/",
      "https://www.facebook.com/village.zone.rastelx"
    ]
  };

  const websiteSchema = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "Village Zone",
    url: "https://store.villagezone.shop",
    potentialAction: {
      "@type": "SearchAction",
      target:
        "https://store.villagezone.shop/shop?search={search_term_string}",
      "query-input": "required name=search_term_string"
    }
  };



  return (
    <>
    <Helmet>
      <title>Shop | VillageZone - Your Destination for Healthy, Preservative-Free, Handcrafted Goodness</title>

      <script type="application/ld+json">
        {JSON.stringify(organizationSchema)}
      </script>

        <script type="application/ld+json">
    {JSON.stringify(websiteSchema)}
  </script>
    </Helmet>

      {/* Breadcrumb */}
      <BreadcrumbThree title={"Shop"} />

      {/* ShopSection */}
      <ShopSection />

      {/* ShippingTwo */}
      <ShippingOne />

    </>
  );
};

export default ShopPage;
